/** Primärnav-Reihenfolge — ohne Lucide, damit Units nicht das Icon-Paket laden. */
export const PRIMARY_PORTAL_NAV_IDS = [
  'chat',
  'suche',
  'diktat',
  'dokumente',
  'akten',
  'kalender',
] as const;
